import React, { useEffect, useState } from 'react';
import { translate } from '../../../services/translate';
import { View } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';
import { crmService } from '../../../services/central-api/crm';

interface Props {
    ticketId: number;
    zIndex: number;
    labelFontSize?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    disabled?: boolean;
    required?: boolean;
}

function TicketReasonDropdown({ form, fieldName, zIndex, disabled, required, ticketId }: Props) {
    const [selectableTicketReasons, setSelectableTicketReasons] = useState<{ label: string; value: number; }[]>([]);

    async function getTicketReasons() {
        try {
            const ticketReasons = await crmService.getSimplifiedTicketReason(ticketId);
            setSelectableTicketReasons(ticketReasons.map((company) => {
                return {
                    value: company.id,
                    label: company.name
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }



    useEffect(() => {
        if (ticketId != 0) {
            getTicketReasons();
        }
    }, []);

    return (
        <View style={{ minWidth: 240 }}>
            <FormDropDownPicker
                label={translate('drpScenario')}
                items={selectableTicketReasons}
                multiple={false}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
                fieldName={fieldName}
                form={form}
                dropDownDirection='TOP'
            />
        </View>

    );
}

export default TicketReasonDropdown;
